"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _MobileAppsColumn = require("./MobileAppsColumn");
Object.keys(_MobileAppsColumn).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MobileAppsColumn[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MobileAppsColumn[key];
    }
  });
});